/**
 * Leaf helper for checking whether an object has only undefined values.
 * Kept out of objectUtils so arrayUtils can use it without the objectUtils ↔ arrayUtils cycle.
 */
export function isEmptyObject(obj: any) {
  return Object.keys(obj).every(key => obj[key] === undefined)
}
